import { FC, ReactElement } from "react";
import {
  styled,
  Typography,
  alpha,
  lighten,
  Avatar,
  Box,
  SvgIconTypeMap,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import PageTitleWrapper from "../PageTitleWrapper";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface PageHeaderProps {
  heading: string;
  subheading: string;
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  Actions?: ReactElement;
  children?: React.ReactNode;
}

const AvatarPageTitle = styled(Avatar)(
  ({ theme }) => `
      width: ${theme.spacing(8)};
      height: ${theme.spacing(8)};
      color: ${theme.colors.primary.main};
      margin-right: ${theme.spacing(2)};
      background: ${theme.palette.mode === 'dark'
      ? theme.colors.alpha.trueWhite[10]
      : theme.colors.alpha.white[50]
    };
      box-shadow: ${theme.palette.mode === 'dark'
      ? '0 1px 0 ' +
      alpha(lighten(theme.colors.primary.main, 0.8), 0.2) +
      ', 0px 2px 4px -3px rgba(0, 0, 0, 0.3), 0px 5px 16px -4px rgba(0, 0, 0, .5)'
      : '0px 2px 4px -3px ' +
      alpha(theme.colors.alpha.black[100], 0.4) +
      ', 0px 5px 16px -4px ' +
      alpha(theme.colors.alpha.black[100], 0.2)
    };
`
);

const PageHeader: FC<PageHeaderProps> = ({ heading, subheading, Icon, Actions }) => {
  return (
    <>
      <PageTitleWrapper>
        <Helmet>
          <title>{heading}</title>
        </Helmet>
        <Box
          display="flex"
          alignItems={{ xs: 'stretch', md: 'center' }}
          flexDirection={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center">
            <AvatarPageTitle variant="rounded">
              {<Icon fontSize="large" sx={{ scale: '1.5'}}/>}
            </AvatarPageTitle>
            <Box>
              <Typography variant="h3" component="h3" gutterBottom color={'primary'}>
                {heading}
              </Typography>
              <Typography variant="subtitle2">
                {subheading}
              </Typography>
            </Box>
          </Box>
          {Actions}
        </Box>
      </PageTitleWrapper>
    </>
  );
};

export default PageHeader;
